import React, { useEffect } from "react";

const ThanksPage = () => {
  useEffect(() => {
    window.history.pushState(null, null, window.location.href);

    const handlePopState = () => {
      window.location.href = window.location.pathname;
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#f6e9dd" }}>
      {/* Top Color Strip */}
      <div
        style={{
          height: "200px",
          backgroundColor: "#d18237",
          borderBottomLeftRadius: "50% 20%",
          borderBottomRightRadius: "50% 20%",
        }}
      ></div>

      {/* Thank You Card */}
      <div className="container">
        <div
          className="shadow p-4 text-center bg-white mx-auto"
          style={{
            maxWidth: "600px",
            marginTop: "-100px",
            borderRadius: "8px",
          }}
        >
          <h2>Thank you for your feedback!</h2>
          <p className="mb-2">We’ve successfully received your response.</p>
          <p>
            Your feedback helps us improve our services. If you have further
            inquiries, feel free to contact us. Have a great day!
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThanksPage;
